import { checkForMorecontentLinks } from '../product-page';
import { checkInStock, getChosenVariatonFromProductObj, paSizeButtonStyling, updateProductPriceHtml, updateVariationDescription } from './product-page-utils';
import { addEventsForFabricVariationSelect, addVariationModalFunctionality } from './varitation-item-functionality';

export function bundleFunctionality() {
  displayBundleItemSku();
  showBundleInitialPrice();
  productBundleAmount();
  addChangeEventHandlerToVariationSelectsBundle();
  addClickEventToChoiceContainerBundle();
  addVariationModalFunctionality();
  addEventsForFabricVariationSelect();
  paSizeButtonStyling();
  translateFabricString();
}

function displayBundleItemSku() {
  if (productInformationObj.type !== 'bundle')
    return;

  const sku = $('.hidden-bundle-product-sku').first().text();
  productInformationObj.firstItemSku = sku;
  const currtext = $('.product-meta .product-sku').text();

  $('.product-meta .product-sku').html(currtext + '<span class="sku">' + sku + '</span>');
}

function productBundleAmount() { // Sätt checked på en dold checkbox som gör att man kan köpa bundleprodukter
  $('.bundled_product_checkbox').prop('checked', true).trigger('change');
}

export function addClickEventToChoiceContainerBundle() {
  for (const choiceContainer of [...document.querySelectorAll('.choices-container')]) {
    if (choiceContainer.classList.contains('pa_size') || choiceContainer.classList.contains('pa_color'))
      continue;

    $('.single-choice', choiceContainer).on('click', function () {
      if ($('.expand', this).length > 0) {
        $(this).toggleClass('expanded');
        return;
      }

      if ($(this).closest('.attribute-select').hasClass('fabric'))
        return;

      const value = $('.choice-name', this).text();

      const idForCorrespondingSelect = $(this).closest('.choices-container').data('choiceFor'); // Behövs för att trigga event på rätt select

      if (!idForCorrespondingSelect)
        return;

      $('[id^=' + idForCorrespondingSelect + ']').val(value);
      $('[id^=' + idForCorrespondingSelect + ']').trigger('change');

      const labelParent = $('[id^=' + idForCorrespondingSelect + ']').closest('.attribute_options');
      $('label', labelParent).text(value);

      $('.attribute-select').css('display', 'none');
      $('body').css('overflow', 'visible');
    });
  }
}

function showBundleInitialPrice() {
  if (!productInformationObj.bundled_item_products || Object.values(productInformationObj.bundled_item_products).length === 0)
    return;

  const firstBundledItem = Object.values(productInformationObj.bundled_item_products)[0];
  if (firstBundledItem.type === 'simple') {
    updateProductPriceHtml(firstBundledItem, true);
    return;
  }

  if (firstBundledItem.variations.length === 0)
    return;

  const firstVariableProduct = firstBundledItem.variations[0];
  updateProductPriceHtml(firstVariableProduct, true);
}

function checkIfBundleItemIsFirstInList(bundleProductEl) {
  const bundleItemRow = bundleProductEl.closest('.bundled_product');

  return $(bundleItemRow).is(':first-child');
}

function updateBundleProductInformationAfterChoice(description, sku = false) {
  if (description && description !== '')
    updateVariationDescription(description);
  else
    updateVariationDescription(productInformationObj.description);

  if (sku && sku !== '')
    $('.product-meta .product-sku .sku').html(sku);

  checkForMorecontentLinks();
}

function showCorrectBundleDetailsEl(sku) {
  const chosenVariationForBundleDetailsEl = document.querySelector('[data-bundle-details-for="' + sku + '"]');

  if (chosenVariationForBundleDetailsEl)
    chosenVariationForBundleDetailsEl.style.display = 'block';
}

function showAvailabilityForBundleItem(bundledProductEL, productObject) {
  if (productObject.non_stock_item)
    return;

  const isAvailable = checkInStock('.bundle_form.cart', productObject.sku);

  if (isAvailable) {
    $('.in_stock_span', bundledProductEL).remove();
    $('.details', bundledProductEL).append('<span class="in_stock_span">' + productPageTranslations.inStockString + '</span>');
  } else {
    $('.in_stock_span', bundledProductEL).remove();
    $('.details', bundledProductEL).append('<span class="in_stock_span">' + productPageTranslations.outOfStockString + '</span>');
  }
}

function addChangeEventHandlerToVariationSelectsBundle() {
  $('.variations select').each(function () {
    const bundledProductEL = $(this).closest('.bundled_product');
    const bundleId = $(this).closest('.cart').data('bundled_item_id');
    const isFirstInBundleInBundledItemList = checkIfBundleItemIsFirstInList(this); // dessa ska uppdatera beskrivning

    $(this).on('change', function (_) {
      $('.hidden-bundle-details', bundledProductEL).hide();

      // Förklaring av flödet!
      // När en select väljs på en bundleprodukt kommer den bara få med sig värdet från selecten in här och vi har inget sku eller liknande att jämföra mot
      // Så det första vi gör är att hitta motsvarande produkt i produtInformationObjektet (mha getChosenVariatonFromProductObj)
      // Därefter kollar vi om det finns ett gömt element på bundlen som innehåller all data för den valda varianten
      // Om detta finns så visas den
      // Därefter läggs ett element till på bundleprodukten som visar om den finns i lager eller inte

      const compareVal = $(this).val();

      if (!compareVal) { // Om man aktivt väljer bort ett val ska den original description visas
        updateBundleProductInformationAfterChoice(productInformationObj.description, productInformationObj.firstItemSku);
      }

      const maybeChosenVariationObj = getChosenVariatonFromProductObj(bundleId, compareVal);

      if (!maybeChosenVariationObj) {
        $('.in_stock_span', bundledProductEL).remove();
        return;
      }

      if (isFirstInBundleInBundledItemList)
        updateBundleProductInformationAfterChoice(maybeChosenVariationObj.variation_description, maybeChosenVariationObj.sku);

      showCorrectBundleDetailsEl(maybeChosenVariationObj.sku);
      showAvailabilityForBundleItem(bundledProductEL, maybeChosenVariationObj);
    });
  });
}

export function updateBundleProductsStockHtml() {
  const allBundleProducts = [...document.querySelectorAll('.bundled_products tr')];

  for (const bundleProduct of allBundleProducts) {
    const sku = bundleProduct.querySelector('.hidden-bundle-product-sku.simple') ? bundleProduct.querySelector('.hidden-bundle-product-sku.simple').textContent : false;
    const isNonStockItem = bundleProduct.querySelector('.non-stock-item-field-text');

    if (!sku || isNonStockItem)
      continue;

    if (checkInStock('.bundle_form.cart', sku)) {
      $('.details', bundleProduct).append('<span class="in_stock_span">' + productPageTranslations.inStockString + '</span>');
    } else {
      $('.details', bundleProduct).append('<span class="in_stock_span">' + productPageTranslations.outOfStockString + '</span>');
    }
  }
}

function translateFabricString() {
  // Det verkar vara en bugg i Bundle pluginet som gör att det är helt jävla omöjligt att få det att översätta attributen
  const fabricTextSE = 'Fodral valfritt tyg';
  const fabricTextEN = 'Optional cover fabric';

  const attributes = [...document.querySelectorAll('.attribute_options')];
  attributes.forEach((option) => {
    const label = option.querySelector('label');

    if (label && label.textContent.includes(fabricTextSE)) {
      label.textContent = fabricTextEN;
    }
  });
}
